export default __webpack_public_path__ + "static/media/logout.1ac7439f.svg";